export const isResolvedPriceSoldOut = (price) => Boolean(price?.isSoldOut);

export const areAllPricesSoldOut = (prices) => {
  const list = Array.isArray(prices) ? prices : [];
  return list.length > 0 && list.every(isResolvedPriceSoldOut);
};

export const getAvailabilityPrices = (variety, priceFilter) => {
  const prices = Array.isArray(variety?.VarietyPrices) ? variety.VarietyPrices : [];
  if (typeof priceFilter !== 'function') return prices;
  return prices.filter(priceFilter);
};

export const isResolvedVarietySoldOut = (variety, priceFilter) =>
  areAllPricesSoldOut(getAvailabilityPrices(variety, priceFilter));

export const isResolvedProductSoldOut = (product, priceFilter) => {
  const varieties = Array.isArray(product?.Varieties) ? product.Varieties : [];
  if (!varieties.length) return false;
  return varieties.every((variety) => isResolvedVarietySoldOut(variety, priceFilter));
};

export const getAvailabilityLabelForPrices = (prices, soldOutLabel = 'Agotada') => {
  const list = Array.isArray(prices) ? prices : [];
  if (!list.length) return 'Sin precios';
  const soldOutCount = list.filter(isResolvedPriceSoldOut).length;
  if (soldOutCount === list.length) return soldOutLabel;
  if (soldOutCount > 0) return 'Parcial';
  return 'Disponible';
};
